import { css } from "@emotion/react";
import { Modal, theme } from "@minted/minted-components";
import React from "react";

const exclusionStyles = {
  detailsHeader: css`
    ${theme.typeStyles.titleLargeStyles};
    color: ${theme.colors.textPrimary};
    padding-bottom: ${theme.spacing.x4};
  `,
  detailsText: css`
    ${theme.typeStyles.bodySmallStyles};
  `,
  modal: css`
    padding: ${theme.spacing.x16};

    ${theme.media.lessThan(theme.breakpoints.small)(css`
      padding: ${theme.spacing.x4};
    `)}
  `,
};

type Props = {
  close: () => void;
  isOpen: boolean;
};

const OnlineInvitationExclusions = ({ close, isOpen }: Props) => (
  <Modal
    mobileFullscreen={true}
    onCloseClick={close}
    open={isOpen}
    size="medium"
  >
    <div css={exclusionStyles.modal} data-cy="exclusionsModal">
      <div css={exclusionStyles.detailsHeader}>Details and exclusions</div>
      <div css={exclusionStyles.detailsText}>
        Offer is available to new customers only. Offer is valid for 10% off
        Fine Art and 20% off everything else. Offer excludes Minted More
        membership program, Photo Op by Minted, art styling services, gift
        cards, custom design services, and items made and sold by third party
        sellers (Direct From Artist and Weddings Marketplace). The full promo
        code value must be used in one transaction. Discount does not apply to
        shipping and tax. Offer cannot be combined with any other offers or
        promotions, including discounted credit.
      </div>
    </div>
  </Modal>
);

export default OnlineInvitationExclusions;
